import type { OrganizationId } from '@/lib/organization-scoping'
import { organizationQueryKeys } from '@/lib/services/organizations/organizations.query'
import type { Organization } from '@/lib/services/organizations/organizations.types'
import type { QueryClient } from '@tanstack/react-query'
import { notFound } from '@tanstack/react-router'

/** Route loaders call this with their query client; route tests stub it without `getQueryData`. */
export function assertNotSalesDemoOrganization(
  queryClient: Pick<QueryClient, 'getQueryData'>,
  organizationId: OrganizationId
) {
  const organization = queryClient.getQueryData?.<Organization>(
    organizationQueryKeys.show(organizationId)
  )

  if (organization?.sales_demo) {
    throw notFound()
  }

  return organization
}
